import React, { memo } from 'react';
import HBAddressCityField from './HBAddressCityField';
import useFormFieldProps, {
    FormFieldProps,
    TFormInputValidationProps,
    useFormInputValidationProps
} from '../HBFormFields/useFormFieldProps';
import type { HBInputFieldProps } from '../HBInputField/HBInputField';

export type HBFormAddressCityFieldProps = Omit<
    FormFieldProps<HBInputFieldProps>,
    TFormInputValidationProps | 'label' | 'ref'
> & {
    /** The currently selected country code. For AU, the label changes to "Suburb". */
    country: string;
    /** Override the auto-derived label (City or Suburb for AU). */
    label?: string;
};

const HBFormAddressCityField = ({
    country,
    label,
    ...props
}: HBFormAddressCityFieldProps) => {
    const fieldProps = useFormFieldProps(props, true);
    const validationProps = useFormInputValidationProps(props.id);

    return (
        <HBAddressCityField
            {...fieldProps}
            {...validationProps}
            country={country}
            label={label}
        />
    );
};

export default memo(HBFormAddressCityField);
